export default {
  methods: {
    $isFieldValid(ref: any, validateUntouched: boolean = false): boolean | null {
      // @ts-ignore
      const field = this.veeFields && this.veeFields[ref]
      if (validateUntouched && field && field.untouched) {
        // @ts-ignore
        return !this.errors.has(ref)
      }
      if (field && (field.dirty || field.validated)) {
        // @ts-ignore
        return !this.errors.has(ref)
      }
      return null
    },
  },
}
